import styled from "styled-components";

export const TileJournalCardsContainer = styled.div`
    display: flex;
    width: 100%;
    overflow: auto;
    gap: 30px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* For iOS devices */
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding: 20px;
    @media(min-width: 768px){
       padding: 35px;
       gap: 60px;
    }
    @media(min-width: 1024px){
        padding: 50px;
        gap: 90px;
    }
    @media(max-height: 880px){
      padding: 35px;
      gap: 60px;
    }
`;

export const TileJournalDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transition: transform .5s ease-out;
  ${props => props?.hiddenBelow && `transform: translateY(60px)`};
`

export const TileJournalItemBackgroundImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.5s ease-in-out;
`

export const TileJournalItemContainer = styled.div`
  flex: 0 0 118.65px;
  height: 208.50px;
  border-radius: 5px;
  background: #EAD8FF;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  &:hover {
    ${TileJournalDetailsContainer} {
      transform: translateY(-20px);
    }

    ${TileJournalItemBackgroundImage} {
      transform: scale(1.05);
    }
  }

  @media(min-width: 768px){
    flex: 0 0 175.65px;
    height: 308.50px;
    border-radius: 10px;
}
@media(min-width: 1024px){
    flex: 0 0 235.65px;
    height: 408.50px;
    border-radius: 15px;
}
@media(max-height: 880px){
  flex: 0 0 175.65px;
  height: 308.50px;
  border-radius: 10px;
}

`

export const TileJournalTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 20px;
    min-height: 40px;
    @media(min-width: 768px){
        font-size: 18px;
        font-weight: 600;
        min-height: 50px;
    }
    @media(max-height: 880px){
      font-size: 18px;
      font-weight: 600;
      min-height: 50px;
    }
`

export const TileJournalCategory = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Outfit;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.34);
    backdrop-filter: blur(8.5px);
    color: #FFFFFF;
    margin-bottom: 9.71px;

    font-size: 9px;
    padding: 3px 9px;
    border-radius: 10px;

    @media(min-width: 768px){
        font-size: 12px;
        padding: 5px 11px;
        border-radius: 20px;
    }
    @media(max-height: 880px){
      font-size: 12px;
      padding: 5px 11px;
      border-radius: 20px;
    }
`

export const TileStyledSeparatorJournal = styled.div`
  height: 3.21px;
  width: 63.68px;
  border-radius: 4px;
  background: #FF5252;
  margin-bottom: 7.15px;

`

export const TileStyledLine = styled.div`
  height: 1.64px;
  width: 80%;
  border-radius: 3px;
  background: #FFFFFF;
  margin-top: 12px;
  @media (max-width: 520px ) {
    margin-top: 12px;
  }
`